import { getBrowserLocale } from './getBrowserLocale';
import { getUrlLocale } from './getUrlLocale';

// 语言代码：http://www.lingoes.cn/zh/translator/langcode.htm
const rules = [
  { test: /^(be_BY)$/i, lang: 'be_by' },
  { test: /^(zh|zh_CN)$/i, lang: 'zh_cn' },
  { test: /^(zh_HK|zh_TW|zh_MO|zh_SG)$/i, lang: 'zh_tw' },
];

// 提取：xx_YY -> xx
// locale默认为简体中文
// 如果传了未知的语言，则返回lang
export const getRuleLocale = (
  locale: string = getUrlLocale() || getBrowserLocale(),
) => {
  locale = locale.toLowerCase();
  const lang = locale.split('_')[0];
  return rules.find(item => item.test.test(locale))?.lang || lang;
};


export const getLocale = (loc = getUrlLocale() || getBrowserLocale()) => {
  return {
    locale: loc.toLowerCase(),
    fallback: getRuleLocale(loc),
    rawLocale: loc
  }
}